import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { Flex } from '@adsk/alloy-react-box';
import { useLocale } from '@adsk/alloy-react-locale';

import getPluginKey from './helpers/getPluginKey';
import { pluginShape } from './helpers/propTypes';

const getPluginName = (plugin) => {
  return <plugin.PluralText lowerCase key={getPluginKey(plugin)} />;
};

const ReferencePickerEmptyState = ({
  style,
  className,
  emptyStateText,
  plugins,
  allowAddingLinks,
}) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  const defaultEmptyStateText = useMemo(() => {
    if (!allowAddingLinks) {
      return T.translate('ADD_REFERENCE_PLACEHOLDER_NO_ADD');
    }
    const options = {
      context: plugins.length,
    };
    if (plugins.length === 1) {
      options.name = getPluginName(plugins[0]);
    } else if (plugins.length > 0 && plugins.length <= 4) {
      const firstPartArr = plugins.reduce((acc, p, index) => {
        if (index < plugins.length - 1) {
          acc.push(getPluginName(p));
          if (index < plugins.length - 2) {
            acc.push(', ');
          }
        }
        return acc;
      }, []);
      options.firstPart = <>{firstPartArr}</>;
      options.lastName = getPluginName(plugins[plugins.length - 1]);
    }

    return T.translate('ADD_REFERENCE_PLACEHOLDER', options);
  }, [T, plugins, allowAddingLinks]);

  const emptyState = emptyStateText || defaultEmptyStateText;

  return (
    <Flex
      className={className}
      justifyContent="center"
      textAlign="center"
      padding="26px 66px"
      color="charcoal700"
      typography="bodyMedium"
      style={style}
    >
      {emptyState}
    </Flex>
  );
};

ReferencePickerEmptyState.propTypes = {
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Empty state text to show instead of the default one */
  emptyStateText: PropTypes.string,
  /** Plugins the user can add links to */
  plugins: PropTypes.arrayOf(pluginShape).isRequired,
  /** Whether or not the user can add linked entities */
  allowAddingLinks: PropTypes.bool,
};

export default ReferencePickerEmptyState;
